var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popup__inner fixed z-40 pb-3 pt-4"},[_c('div',{staticClass:"popup__body flex justify-center flex-col items-center"},[_c('font-awesome-icon',{staticClass:"text-xl text-white",attrs:{"icon":"shopping-bag"}}),_c('p',{staticClass:"text-xs mt-1 text-white text-NotoSansRegular"},[_vm._v("加入購物車")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }